import AbstractRequestTask from "../AbstractRequestTask";
import getAppConfig from "../../../config/appConfig";
import settings from "../../../devices/all/settings";
import {ENABLE_MODAL_RETRIES} from '../../RequestManagerConstants';

class RadiosTask extends AbstractRequestTask {
  constructor(service = "", user, params, headers) {
    super();
    this._config = getAppConfig();
    this._service = service;
    this.method = params.method;
    this._params = {
      ...params,
    };
    this._headers = headers;

    this.cm_access_token = this._headers.cm_access_token ? this._headers.cm_access_token : null;
    if(this._headers.cm_access_token) {
      delete this._headers.cm_access_token;
    }
  }

  getMethod() {
    return "GET";
  }

  getEncType() {
    return "application/x-www-form-urlencoded";
  }

  isValid(data) {
    if (
      data.errors &&
      !data.ribbons &&
      !data.albumDetail &&
      !data.playlistDetail
    ) {
      return false;
    }
    return true;
  }

  getUrl() {
    if (this._service === "genreRadios") {
      return `${this._config.end_point_music}/middleware/${this._service}`;
    }
    return `${this._config.end_point_music}/middleware/radios/${this._service}`;
  }

  getParams() {
    const params = super.getParams();
    delete params.HKS;
    delete params.api_version;
    delete params.user_id;
    const { tenant_code } = settings;
    params.tenant_code = tenant_code;
    params.version = '2.0.0';
    
    if(this.cm_access_token) {
      params.cm_access_token = this.cm_access_token;
    }

    return { ...this._params, ...params };
  }

  getHeaders() {
    const headers = {
      ...this._headers
    };
    return headers;
  }

  success(data, b) {
    this.resolve(data);
  }

  getShowErrorModal(){
		return ENABLE_MODAL_RETRIES;
	}
}

export default RadiosTask;



// WEBPACK FOOTER //
// ./src/requests/tasks/music/RadiosTask.js